//Imports
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//Utils
import { openExternalURL } from '../../utils/functions';
//Css
import './style.css'
//
export default function FloatButton(props){
    return (
        <div className="float_button m-5" {...props} onClick={()=>openExternalURL('Whastapp_Button', 'Redirecionado para o whatsapp', props.url)}>
            <div className="mr-auto ml-auto">
                <FontAwesomeIcon icon={props.icon} size={props.size} />
            </div>
        </div>
    )
}